<template>
  <el-dropdown trigger="click" :visible-arrow="false" @command="onThemeClick" placement="bottom">
    <span class="dashboard-icon-group">
      <el-tooltip content="테마" placement="top">
        <div v-if="type === 'img'" class="btn-full-theme mr-r5" type="content"></div>
        <el-button v-else class="btn-theme" size="medium" type="content"></el-button>
      </el-tooltip>
    </span>
    <el-dropdown-menu class="theme-select-dropdown" slot="dropdown">
      <el-dropdown-item :class="[themeSelectCls(DashboardConst.THEME.WHITE), 'dashboard-theme-tool']" :command="DashboardConst.THEME.WHITE">
        <div :class="themeIconCls(DashboardConst.THEME.WHITE, 'white')">
          <div style="padding-left: 25px; padding-top: 4px;">화이트</div>
          <!-- <span style="padding-left: 25px;">화이트</span> -->
        </div>
      </el-dropdown-item>
      <el-dropdown-item :class="[themeSelectCls(DashboardConst.THEME.BLACK), 'dashboard-theme-tool']" :command="DashboardConst.THEME.BLACK">
        <div :class="themeIconCls(DashboardConst.THEME.BLACK, 'black')">
          <div style="padding-left: 25px; padding-top: 4px;">블랙</div>
          <!-- <span style="padding-left: 25px;">블랙</span> -->
        </div>
      </el-dropdown-item>
      <el-dropdown-item :class="[themeSelectCls(DashboardConst.THEME.GRADIENT), 'dashboard-theme-tool']" :command="DashboardConst.THEME.GRADIENT">
        <div :class="themeIconCls(DashboardConst.THEME.GRADIENT, 'gradient')">
          <div style="padding-left: 25px; padding-top: 4px;">그라디언트</div>
          <!-- <span style="padding-left: 25px;">그라디언트</span> -->
        </div>
      </el-dropdown-item>
      <el-dropdown-item :class="[themeSelectCls(DashboardConst.THEME.PARTICLE), 'dashboard-theme-tool']" :command="DashboardConst.THEME.PARTICLE">
        <div :class="themeIconCls(DashboardConst.THEME.PARTICLE, 'animation')">
          <div style="padding-left: 25px; padding-top: 4px;">애니메이션</div>
          <!-- <span style="padding-left: 25px;">애니메이션</span> -->
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import DashboardConst from '@/constants/dashboard';

import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDashboardThemeDropdown',
  mixins: [Base],
  props: {
    type: {
      type: String,
      default: 'button',
    },
  },
  data() {
    return {
      DashboardConst,
    };
  },
  computed: {
    themeSelectCls() {
      const dashboardTheme = this.dashboardTheme;
      return (theme) => {
        if (theme === dashboardTheme) {
          return 'selected';
        }
        return 'unselected';
      };
    },
    themeIconCls() {
      return (theme, type) => `${this.themeSelectCls(theme)} icon_${type}`;
      // return (theme, type) => (this.themeSelectCls(theme) === 'unselected' ? `icon_${type}` : `${this.themeSelectCls(theme)} icon_${type}`);
    },
  },
  methods: {
    /**
     * 다운로드 버튼 클릭시 나타나는 dropdown 메뉴의 클릭 이벤트
     * @author JungJioon(ryunnnne)
     * @param  {[type]} command [description]
     * @return {[type]}         [description]
     */
    onThemeClick(command) {
      this.dashboardTheme = command;
    },
  },
};
</script>

<style lang="scss">
.btn-full-theme{
  width: 38px;
	min-width: 38px;
	max-width: 38px;
	height: 36px;
	min-height: 36px;
	max-height: 36px;
  cursor: pointer;
}
.theme-select-dropdown {
  background-color: #FCFAFB;
  width: 115px;
  .el-dropdown-menu__item {
    &.selected {
      // background-color: #E5E4E4;
    }
  }
  // .unselected:hover {
  //   background-color: #F1F0F0;
  //   color: #333;
  // }
  .el-dropdown-menu__item {
    font-size: 13px;
    font-weight: 400;
  }
  &.el-dropdown-menu--mini {
    padding: 10px 12px;
    border-radius: 2px;
    .el-dropdown-menu__item {
      padding: 0px;
      line-height: 27px;
    }

  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: transparent;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DashboardThemeDropdown.vue